import {Component, inject, Inject, OnInit} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {GameService} from "../../../services/game.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {SnackbarService} from "../../../services/snackbar.service";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IUploadImageToAzure} from "../../../interfaces/IUploadImageToAzure";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {AssetManagementService} from "../../../services/asset-management.service";

@Component({
  selector: 'app-edit-qr-code-image',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatButton,
    MatIcon
  ],
  templateUrl: './edit-qr-code-image.component.html',
  styleUrl: './edit-qr-code-image.component.css'
})
export class EditQrCodeImageComponent implements OnInit {

  public assetManagementService: AssetManagementService = inject(AssetManagementService);
  private gameService: GameService = inject(GameService)
  private activeUserService: ActiveUserService = inject(ActiveUserService)
  private snackBarService: SnackbarService = inject(SnackbarService)
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  constructor(private dialogRef: MatDialogRef<EditQrCodeImageComponent>,
              @Inject(MAT_DIALOG_DATA) private game: IGameQueryResult) {
  }

  ngOnInit() {
    this.assetManagementService.checkForExistingQrCodeImage(this.game.Subdomain);
  }

  onQrCodeFileSelected(event: any) {
    this.assetManagementService.handleQrCodeSelected(event);
  }

  saveQRCode() {
    if (!this.assetManagementService.qrCodeImage) {
      this.dialogRef.close();
    }

    this.uiState = UIStateEnum.ShowLoading;

    const formData = new FormData();

    if (this.assetManagementService.qrCodeImage) {
      formData.append('file', this.assetManagementService.qrCodeImage, 'qrcode.png');

      const new_logo_request: IUploadImageToAzure = {
        gameId: this.game.Id,
        image: formData,
        adminId: this.activeUserService.activeUser().Id
      };

      this.gameService.uploadGameImage(new_logo_request).subscribe({
        next: (res: any) => {
          if (res.status == 200) {
            this.uiState = UIStateEnum.ShowData;
            this.snackBarService.openSuccessfulSnackBar('Successfully uploaded Game QR Code.');
            this.dialogRef.close();
          }
        },
        error: () => {
          this.uiState = UIStateEnum.ShowData;
          this.snackBarService.openErrorSnackBar('Failed to upload Game QR Code.');
        }
      });
    }
  }
}
